import React, { useEffect, useContext, useState, useRef } from 'react'

import Moment from 'moment'
import { Divider, Box, Dialog, Button, TextField, FormControl, Select, MenuItem, Table, TableContainer, TableRow, TableBody, TableHead, TableCell, Paper } from '@material-ui/core'

import { ReactComponent as XIcon } from '../../../../images/x-icon.svg'
import loadingGIF from '../../../../images/loadingGIF.gif'
import { Trash2 as TrashIcon } from 'react-feather';
import { Download as DownloadIcon } from 'react-feather';
import { Edit as EditIcon } from 'react-feather';

import isEmail from "validator/lib/isEmail"
import EmailEditor, { EditorRef, EmailEditorProps } from 'react-email-editor';
import { useConfirm } from "material-ui-confirm";

import { SocketContext } from "../../../../contexts/SocketContext"
import UserContext from "../../../../contexts/UserContext"

import APIS from "../../../../utils/APIS"


Moment.locale('fr')

const DialogContent = ({ title, subTitle, onClose, moduleInfos, groupeID, groupeName, getMailingForThisContent, mailings, actEditMailing, user }) => {

  const muiConfirm = useConfirm();

  const emailEditorRef = useRef(null);

  const [isUnlayerEditorReady, setIsUnlayerEditorReady] = useState(false)

  const loadAllTemplates = () => {
    APIS.getMailingTemplates().then((results) => {
      if (results?.templates) {
        setAllTemplates(results?.templates)
      } else {
        alert("Error load templates")
      }
      console.log(results)
    })
  }

  const onReadyUnlayer = (unlayer) => {
    emailEditorRef.current?.editor?.addEventListener('design:updated', function (data) {
      emailEditorRef.current?.editor?.exportHtml((data) => {
        setActEmailJSON(JSON.stringify(data.design))
      })
    })
    setIsUnlayerEditorReady(true)
    if (mailings && actEditMailing) {
      let find = mailings.find((el) => el.id === actEditMailing)
      if (find) {
        const unlayer = emailEditorRef.current?.editor;
        unlayer?.loadDesign(JSON.parse(find.mailJSON))
      }
    }
  };

  const [testSendingDialog, setTestSendingDialog] = useState(false)
  const [testSendingEmail, setTestSendingEmail] = useState("")

  const [saveTemplateDialog, setSaveTemplateDialog] = useState(false)
  const [newTemplateName, setNewTemplateName] = useState("")
  const [isSavingNewTemplate, setIsSavingNewTemplate] = useState(false)

  const [openTemplateDialog, setOpenTemplateDialog] = useState(false)
  const [allTemplates, setAllTemplates] = useState([])

  const [actEmailJSON, setActEmailJSON] = useState("")
  const [mailName, setMailName] = useState("")
  const [mailObject, setMailObject] = useState("")
  const [mailDest, setMailDest] = useState("all")

  const [timingSource, setTimingSource] = useState("openDate")
  const [deltaTimingOperator, setDeltaTimingOperator] = useState("-")
  const [deltaTimingNbr, setDeltaTimingNbr] = useState(0)
  const [deltaTimingUnit, setDeltaTimingUnit] = useState("J")
  const [deltaTimingOperator2, setDeltaTimingOperator2] = useState("-")
  const [deltaTimingNbr2, setDeltaTimingNbr2] = useState(0)
  const [deltaTimingUnit2, setDeltaTimingUnit2] = useState("H")
  const [finalTiming, setFinalTiming] = useState(null)


  useEffect(() => {
    let source = Moment(moduleInfos[timingSource], "YYYY-MM-DD")

    let final = null;
    if (deltaTimingOperator === "+") {
      final = source.add(deltaTimingNbr, deltaTimingUnit === "H" ? "hours" : "days")
    } else if (deltaTimingOperator === "-") {
      final = source.subtract(deltaTimingNbr, deltaTimingUnit === "H" ? "hours" : "days")
    }

    if (deltaTimingOperator2 === "+") {
      let final2 = final.add(deltaTimingNbr2, deltaTimingUnit2 === "H" ? "hours" : "days")
      setFinalTiming(final2.format("DD/MM/YYYY HH:mm"))
    } else if (deltaTimingOperator2 === "-") {
      let final2 = final.subtract(deltaTimingNbr2, deltaTimingUnit2 === "H" ? "hours" : "days")
      setFinalTiming(final2.format("DD/MM/YYYY HH:mm"))
    }
  }, [moduleInfos, timingSource, deltaTimingOperator, deltaTimingNbr, deltaTimingUnit, deltaTimingOperator2, deltaTimingNbr2, deltaTimingUnit2])

  useEffect(() => {
    if (mailings && actEditMailing) {
      let find = mailings.find((el) => el.id === actEditMailing)
      if (find) {
        setMailName(find.name)
        setMailObject(find.mailObject)
        setMailDest(find.mailDest)
        setTimingSource(find.timingSource)
        setDeltaTimingOperator(find.deltaTimingOperator)
        setDeltaTimingNbr(find.deltaTimingNbr)
        setDeltaTimingUnit(find.deltaTimingUnit)
        setDeltaTimingOperator2(find.deltaTimingOperator2)
        setDeltaTimingNbr2(find.deltaTimingNbr2)
        setDeltaTimingUnit2(find.deltaTimingUnit2)
        setActEmailJSON(find.mailJSON)
      }
    }
  }, [mailings, actEditMailing])

  const [haveToSave, setHaveToSave] = useState(false)
  useEffect(() => {
    if (mailings && actEditMailing) {
      //édition, on compare
      let find = mailings.find((el) => el.id === actEditMailing)
      if (find) {
        if (mailName !== find.name || mailObject !== find.mailObject || mailDest !== find.mailDest || timingSource !== find.timingSource ||
          deltaTimingOperator !== find.deltaTimingOperator || deltaTimingNbr !== find.deltaTimingNbr || deltaTimingUnit !== find.deltaTimingUnit ||
          deltaTimingOperator2 !== find.deltaTimingOperator2 || deltaTimingNbr2 !== find.deltaTimingNbr2 || deltaTimingUnit2 !== find.deltaTimingUnit2 ||
          actEmailJSON !== find.mailJSON) {
          setHaveToSave(true)
        } else {
          setHaveToSave(false)
        }
      } else {
        setHaveToSave(true)
      }
    } else {
      //création
      setHaveToSave(true)
    }
  }, [mailName, mailObject, mailDest, timingSource, deltaTimingOperator, deltaTimingNbr, deltaTimingUnit, deltaTimingOperator2, deltaTimingNbr2, deltaTimingUnit2, actEmailJSON])

  return (
    <Box sx={{
      padding:"20px",
      height: "calc(100vh - 64px)"
    }}>
      <Box sx={{display:"flex", justifyContent:"space-between"}}>
        <Box sx={{fontSize:"25px", fontWeight:"bold", textAlign:"center", display:"flex", alignItems:"center", gap:"5px"}}>
          {title}{' "'}{mailName}{'"'}
          <font style={{fontSize:"17px"}}>
            {subTitle}
          </font>
        </Box>
        <XIcon width="20px" height="20px" onClick={onClose} style={{
          cursor:"pointer",
          color:"black"
        }}/>
      </Box>
      <Box sx={{display:"flex", height:"calc(100% - 40px)", paddingTop:"10px"}}>
        <Box sx={{flex: 0.3, height:"100%"}}>
          <Box sx={{display:"flex", flexDirection:"column", justifyContent:"space-between", height:"100%", paddingRight:"10px"}}>
            <Box>
              <Box sx={{borderBottom:"1px dashed black", paddingBottom:"15px"}}>
                <font style={{fontSize:"16px"}}>
                  Nom du mail : (privé)
                </font>
                <br/>
                <TextField value={mailName}
                  size="small"
                  sx={{marginTop:"3px", marginLeft:"10px", width:"calc(100% - 20px)", height:"40px"}}
                  onChange={(e) => { setMailName(e.target.value) }}
                />
              </Box>
              <Box sx={{marginTop:"20px", paddingBottom:"15px", borderBottom:"1px dashed black",}}>
                <font style={{fontSize:"16px"}}>
                  Objet du mail :
                </font>
                <br/>
                <TextField value={mailObject}
                  size="small"
                  sx={{marginTop:"3px", marginLeft:"10px", width:"calc(100% - 20px)", height:"40px"}}
                  onChange={(e) => { setMailObject(e.target.value) }}
                />
                <br/><br/>
                <font style={{fontSize:"16px"}}>
                  Destinataires du mail :
                </font>
                <br/>
                <FormControl size="small" sx={{marginTop:"3px", marginLeft:"10px", width:"calc(100% - 20px)", height:"40px"}}>
                  <Select value={mailDest} onChange={(e) => { setMailDest(e.target.value) }} >
                    <MenuItem value="all">Tous</MenuItem>
                    <MenuItem value="notStarted">N'ayant pas commencé</MenuItem>
                    <MenuItem value="inProgress">En cours</MenuItem>
                    <MenuItem value="ended">Ayant terminé</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <Box sx={{marginTop:"20px",}}>
                <font style={{fontSize:"16px"}}>
                  Timing source :
                </font>
                <br/>
                <FormControl size="small" sx={{marginTop:"3px", marginLeft:"10px", width:"calc(100% - 20px)", height:"40px"}}>
                  <Select value={timingSource} onChange={(e) => { setTimingSource(e.target.value) }} >
                    <MenuItem value="openDate">{Moment(moduleInfos.openDate, "YYYY-MM-DD").format("DD/MM/YYYY HH:mm")} (ouverture)</MenuItem>
                    <MenuItem value="closeDate">{Moment(moduleInfos.closeDate, "YYYY-MM-DD").format("DD/MM/YYYY HH:mm")} (fermeture)</MenuItem>
                  </Select>
                </FormControl>
                <br/><br/>
                <font style={{fontSize:"16px"}}>
                  Delta timing :
                </font>
                <br/>
                <Box sx={{marginTop:"3px", marginLeft:"10px", display:"flex", gap:"15px"}}>
                  <FormControl size="small" sx={{height:"40px"}}>
                    <Select value={deltaTimingOperator2} sx={{width:"57px"}} onChange={(e) => { setDeltaTimingOperator2(e.target.value) }} >
                      <MenuItem value="-">-</MenuItem>
                      <MenuItem value="+">+</MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl size="small" sx={{height:"40px"}}>
                    <Select value={deltaTimingNbr2} sx={{width:"65px"}} onChange={(e) => { setDeltaTimingNbr2(e.target.value) }} >
                      {[...Array(24)].map((e, i) => <MenuItem key={i} value={i}>{i}</MenuItem>)}
                    </Select>
                  </FormControl>

                  <FormControl size="small" sx={{height:"40px"}}>
                    <Select value={deltaTimingUnit2} sx={{width:"60px"}} onChange={(e) => { setDeltaTimingUnit2(e.target.value) }} >
                      <MenuItem value="H">H</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
                <Box sx={{marginTop:"3px", marginLeft:"10px", display:"flex", gap:"15px"}}>
                  <FormControl size="small" sx={{height:"40px"}}>
                    <Select value={deltaTimingOperator} sx={{width:"57px"}} onChange={(e) => { setDeltaTimingOperator(e.target.value) }} >
                      <MenuItem value="-">-</MenuItem>
                      <MenuItem value="+">+</MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl size="small" sx={{height:"40px"}}>
                    <Select value={deltaTimingNbr} sx={{width:"65px"}} onChange={(e) => { setDeltaTimingNbr(e.target.value) }} >
                      {[...Array(24)].map((e, i) => <MenuItem key={i} value={i}>{i}</MenuItem>)}
                    </Select>
                  </FormControl>

                  <FormControl size="small" sx={{height:"40px"}}>
                    <Select value={deltaTimingUnit} sx={{width:"60px"}} onChange={(e) => { setDeltaTimingUnit(e.target.value) }} >
                      <MenuItem value="J">J</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
                <br/>
                <font style={{fontSize:"16px"}}>
                  Timing final (envoi):
                </font>
                <br/>
                <font style={{marginTop:"3px", marginLeft:"10px", fontSize:"16px", fontWeight:"bold"}}>
                  {finalTiming}
                </font>
              </Box>
              <Box sx={{paddingRight:"5px", marginTop:"20px", marginBottom:"10px", display:"flex", justifyContent:"flex-end"}}>
                <Button
                  disabled={!isUnlayerEditorReady || mailName.trim().length < 3 || mailObject.trim().length < 3 || !haveToSave}
                  variant="contained"
                  size="large"
                  sx={{ minHeight:"35px !important" }}
                  onClick={() => {
                    if (mailings && actEditMailing) {
                      //édition
                      const unlayer = emailEditorRef.current?.editor;
                      unlayer?.exportHtml((data) => {
                        let values = {
                          id : actEditMailing,
                          groupeID : groupeID,
                          contentID : moduleInfos.id,
                          name : mailName,
                          mailObject : mailObject,
                          mailDest : mailDest,
                          timingSource : timingSource,
                          deltaTimingOperator : deltaTimingOperator,
                          deltaTimingNbr : deltaTimingNbr,
                          deltaTimingUnit : deltaTimingUnit,
                          deltaTimingOperator2 : deltaTimingOperator2,
                          deltaTimingNbr2 : deltaTimingNbr2,
                          deltaTimingUnit2 : deltaTimingUnit2,
                          finalTiming : Moment(finalTiming, "DD/MM/YYYY HH:mm").toISOString(true),
                          mailJSON : JSON.stringify(data.design),
                          mailHTML : data.html,
                        }

                        //on check si tout est ok
                        if (Moment(finalTiming, "DD/MM/YYYY HH:mm").isBefore(Moment())) {
                          alert("La date/heure programmée ne peut pas être inférieur à la date/heure actuelle")
                        } else {
                          APIS.editMailing(values).then((result) => {
                            if (result?.isOk) {
                              getMailingForThisContent()
                              onClose()
                            } else {
                              alert("Error")
                            }
                          })
                        }
                      })
                    } else {
                      //création
                      const unlayer = emailEditorRef.current?.editor;
                      unlayer?.exportHtml((data) => {
                        let values = {
                          groupeID : groupeID,
                          contentID : moduleInfos.id,
                          name : mailName,
                          mailObject : mailObject,
                          mailDest : mailDest,
                          timingSource : timingSource,
                          deltaTimingOperator : deltaTimingOperator,
                          deltaTimingNbr : deltaTimingNbr,
                          deltaTimingUnit : deltaTimingUnit,
                          deltaTimingOperator2 : deltaTimingOperator2,
                          deltaTimingNbr2 : deltaTimingNbr2,
                          deltaTimingUnit2 : deltaTimingUnit2,
                          finalTiming : Moment(finalTiming, "DD/MM/YYYY HH:mm").toISOString(true),
                          mailJSON : JSON.stringify(data.design),
                          mailHTML : data.html,
                        }

                        //on check si tout est ok
                        if (Moment(finalTiming, "DD/MM/YYYY HH:mm").isBefore(Moment())) {
                          alert("La date/heure programmée ne peut pas être inférieur à la date/heure actuelle")
                        } else {
                          APIS.addMailing(values).then((result) => {
                            if (result?.isOk) {
                              getMailingForThisContent()
                              onClose()
                            } else {
                              alert("Error")
                            }
                          })
                        }
                      })
                    }
                  }}
                >
                  {(mailings && actEditMailing) ? "Sauvegarder" : "Créer"}
                </Button>
              </Box>
            </Box>
            {/* GESTION TEMPLATE */}
            <Box>
              <Box sx={{display:"flex", gap:"15px", paddingRight:"10px", paddingTop:"10px", paddingBottom:"10px", borderTop:"1px dashed black"}}>
                <Button
                  disabled={!isUnlayerEditorReady || mailName.trim().length < 3 || mailObject.trim().length < 3 || haveToSave}
                  variant="contained"
                  size="small"
                  sx={{ minHeight:"35px !important" }}
                  onClick={() => { setTestSendingDialog(true) }}
                >
                  Tester l'envoi
                </Button>
              </Box>
              <Box sx={{display:"flex", gap:"15px", paddingRight:"10px", paddingTop:"10px", borderTop:"1px dashed black"}}>
                <Button
                  disabled={!isUnlayerEditorReady}
                  variant="contained"
                  size="small"
                  sx={{ minHeight:"35px !important" }}
                  onClick={() => { loadAllTemplates(); setOpenTemplateDialog(true) }}
                >
                  Ouvrir un template
                </Button>
                <Button
                  disabled={!isUnlayerEditorReady}
                  variant="contained"
                  size="small"
                  sx={{ minHeight:"35px !important" }}
                  onClick={() => { setSaveTemplateDialog(true) }}
                >
                  Ajouter aux templates
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box sx={{borderLeft:"1px solid black", flex: 0.7, height:"100%", position:"relative"}}>
          {isUnlayerEditorReady === false &&
            <img src={loadingGIF} style={{position:"absolute", left:"50%", top:"50%", height:"100px", transform: "translate(-50%, -50%)"}}/>
          }
          <EmailEditor
            ref={emailEditorRef}
            onReady={onReadyUnlayer}
            minHeight="100%"
            options={{
              version: "latest",
              tools: {
                image: {
                  enabled: false
                },
                form: {
                  enabled: false
                },
                menu: {
                  enabled: false
                }
              },
              mergeTags: {
                first_and_last_name: {
                  name: "Prénom + Nom",
                  value: "{{first_and_last_name}}",
                  sample: user.name
                },
                groupe_name: {
                  name: "Nom du groupe",
                  value: "{{groupe_name}}",
                  sample: groupeName
                },
                module_name: {
                  name: "Nom du module",
                  value: "{{module_name}}",
                  sample: moduleInfos.name
                },
                open_date: {
                  name: "Date d'ouverture",
                  value: "{{open_date}}",
                  sample: Moment(moduleInfos.openDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                },
                close_date: {
                  name: "Date de fermeture",
                  value: "{{close_date}}",
                  sample: Moment(moduleInfos.closeDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                },
              }
            }}
          />
        </Box>
      </Box>

      {/* TEST SENDING DIALOG */}
      <Dialog
        fullWidth={true}
        maxWidth="sm"
        open={testSendingDialog}
        onClose={() => { }}
        PaperProps={{
          sx : {
            color:"black",
          }
        }}
      >
        <Box sx={{
          padding:"20px",
        }}>
          <Box sx={{display:"flex", justifyContent:"space-between"}}>
            <Box sx={{fontSize:"25px", fontWeight:"bold", textAlign:"center", display:"flex", alignItems:"center", gap:"5px"}}>
              Tester l'envoi
            </Box>
            <XIcon width="20px" height="20px" onClick={() => {
              setTestSendingEmail("")
              setTestSendingDialog(false)
            }} style={{
              cursor:"pointer",
              color:"black"
            }}/>
          </Box>
          <Box sx={{padding:"0px 10px"}}>
            <Box sx={{marginTop:"30px"}}>
              <Box sx={{display:"flex", alignItems:"center", gap:"10px"}}>
                Email de test : <TextField value={testSendingEmail} size="small" sx={{width:"380px", height:"40px"}} onChange={(e) => { setTestSendingEmail(e.target.value) }}/>
              </Box>
            </Box>
          </Box>
          <Box sx={{display:"flex", justifyContent:"center", marginTop:"40px"}}>
            <Box sx={{display:"flex", gap:"30px"}}>
              <Button
                variant="contained"
                size="large"
                sx={{ minHeight:"35px !important" }}
                onClick={() => {
                  setTestSendingEmail("")
                  setTestSendingDialog(false)
                }}
              >
                Fermer
              </Button>
              <Button
                disabled={!isEmail(testSendingEmail)}
                variant="contained"
                size="large"
                sx={{ minHeight:"35px !important" }}
                onClick={() => {
                  APIS.testSendingMailing({id : actEditMailing, email : testSendingEmail, userName : user.name}).then((result) => {
                    if (result?.isOk === true) {
                      setTestSendingEmail("")
                      setTestSendingDialog(false)
                      alert("Email envoyé")
                    } else {
                      setTestSendingEmail("")
                      setTestSendingDialog(false)
                      alert("Error")
                    }
                  })
                }}
              >
                Envoyer
              </Button>
            </Box>
          </Box>
        </Box>
      </Dialog>

      {/* SAVE TEMPLATE DIALOG */}
      <Dialog
        fullWidth={true}
        maxWidth="sm"
        open={saveTemplateDialog}
        onClose={() => { }}
        PaperProps={{
          sx : {
            color:"black",
          }
        }}
      >
        <Box sx={{
          padding:"20px",
        }}>
          <Box sx={{display:"flex", justifyContent:"space-between"}}>
            <Box sx={{fontSize:"25px", fontWeight:"bold", textAlign:"center", display:"flex", alignItems:"center", gap:"5px"}}>
              Ajouter un template
            </Box>
            <XIcon width="20px" height="20px" onClick={() => {
              if (isSavingNewTemplate === false) {
                setNewTemplateName("")
                setSaveTemplateDialog(false)
              }
            }} style={{
              cursor:"pointer",
              color:"black"
            }}/>
          </Box>
          <Box sx={{padding:"0px 10px"}}>
            <Box sx={{marginTop:"30px"}}>
              <Box sx={{display:"flex", alignItems:"center", gap:"10px"}}>
                Nom du template : <TextField value={newTemplateName} size="small" sx={{width:"380px", height:"40px"}} onChange={(e) => { setNewTemplateName(e.target.value) }}/>
              </Box>
            </Box>
          </Box>
          <Box sx={{display:"flex", justifyContent:"center", marginTop:"40px"}}>
            <Box sx={{display:"flex", gap:"30px"}}>
              <Button
                variant="contained"
                size="large"
                sx={{ minHeight:"35px !important" }}
                onClick={() => {
                  if (isSavingNewTemplate === false) {
                    setNewTemplateName("")
                    setSaveTemplateDialog(false)
                  }
                }}
              >
                Fermer
              </Button>
              <Button
                disabled={newTemplateName.trim().length < 3 || isSavingNewTemplate}
                variant="contained"
                size="large"
                sx={{ minHeight:"35px !important" }}
                onClick={() => {
                  setIsSavingNewTemplate(true)

                  try {
                    const unlayer = emailEditorRef.current?.editor;
                    unlayer?.exportHtml((data) => {
                      let values = {
                        name : newTemplateName,
                        json : JSON.stringify(data.design)
                      }
                      APIS.addMailingTemplate(values).then((result) => {
                        if (result?.isOk) {
                          if (result?.templates) { setAllTemplates(result?.templates) }
                          setNewTemplateName("")
                          setSaveTemplateDialog(false)
                          setIsSavingNewTemplate(false)
                        } else {
                          setIsSavingNewTemplate(false)
                          alert("Error")
                        }
                      })
                    });
                  } catch(e) {
                    setIsSavingNewTemplate(false)
                    alert("Error")
                  }
                }}
              >
                Ajouter
                {isSavingNewTemplate &&
                  <img src={loadingGIF} style={{marginLeft:"10px", height:"25px"}}/>
                }
              </Button>
            </Box>
          </Box>
        </Box>
      </Dialog>

      {/* OPEN TEMPLATE DIALOG */}
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={openTemplateDialog}
        onClose={() => { }}
        PaperProps={{
          sx : {
            color:"black",
          }
        }}
      >
        <Box sx={{
          padding:"20px",
        }}>
          <Box sx={{display:"flex", justifyContent:"space-between"}}>
            <Box sx={{fontSize:"25px", fontWeight:"bold", textAlign:"center", display:"flex", alignItems:"center", gap:"5px"}}>
              Ouvrir un template
            </Box>
            <XIcon width="20px" height="20px" onClick={() => { setOpenTemplateDialog(false) }} style={{
              cursor:"pointer",
              color:"#black"
            }}/>
          </Box>
          <Box sx={{padding:"0px 10px"}}>
            <TableContainer sx={{marginTop:"20px"}} component={Paper}>
              <Table sx={{ minWidth: "100%" }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Nom</TableCell>
                    <TableCell sx={{width:"140px"}}>Crée le</TableCell>
                    <TableCell align="center" sx={{width:"75px"}}>Supprimer</TableCell>
                    <TableCell align="center" sx={{width:"75px"}}>Ouvrir</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {allTemplates.map((row) => (
                    <TableRow
                      key={row.id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {row.name}
                      </TableCell>
                      <TableCell sx={{width:"140px"}}>{Moment(row.createdAt).format("DD/MM/YYYY HH:mm")}</TableCell>
                      <TableCell align="center" sx={{padding:0, width:"75px"}}>
                        <TrashIcon
                          style={{cursor: "pointer"}}
                          color="black"
                          size={21}
                          onClick={() => {
                            muiConfirm({ title: "Êtes vous sûrs ?", description: "La suppression d'un template est définitive.", confirmationText:"Supprimer", cancellationText:"Annuler"})
                              .then(() => {
                                APIS.removeMailingTemplate({id : row.id}).then((result) => {
                                  if (result?.isOk === true) {
                                    if (result?.templates) { setAllTemplates(result?.templates) }
                                  } else {
                                    alert("Error")
                                  }
                                })
                              })
                              .catch(() => { });
                          }}
                        />
                      </TableCell>
                      <TableCell align="center" sx={{padding:0, width:"75px"}}>
                        <DownloadIcon
                          style={{cursor: "pointer"}}
                          color="black"
                          size={21}
                          onClick={() => {
                            muiConfirm({ title: "Êtes vous sûrs ?", description: "Le mail actuel sera remplacé par le template.", confirmationText:"Ouvrir", cancellationText:"Annuler"})
                              .then(() => {
                                const unlayer = emailEditorRef.current?.editor;
                                unlayer?.loadDesign(JSON.parse(row.json))
                                setOpenTemplateDialog(false)
                              })
                              .catch(() => { });
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box sx={{display:"flex", justifyContent:"center", marginTop:"40px"}}>
            <Box sx={{display:"flex", gap:"30px"}}>
              <Button
                variant="contained"
                size="large"
                sx={{ minHeight:"35px !important" }}
                onClick={() => { setOpenTemplateDialog(false) }}
              >
                Fermer
              </Button>
            </Box>
          </Box>
        </Box>
      </Dialog>

    </Box>
  )
}

const GroupMailing = ({ groupeName, groupeID, moduleInfos, hasChanged, updateMailingLists }) => {
  const muiConfirm = useConfirm();

  const socket = useContext(SocketContext)
  const { currentUser } = useContext(UserContext)

  const [dialogOpen, setDialogOpen] = useState(false)
  const [actEditMailing, setActEditMailing] = useState(null)

  const [mailings, setMailings] = useState([])

  if (groupeID === null || groupeID === undefined) {
    hasChanged = true
  }

  const getMailingForThisContent = () => {
    if (groupeID !== undefined && moduleInfos?.id !== undefined) {
      APIS.getMailingByGroupAndContent({groupeID : groupeID, contentID : moduleInfos?.id}).then((results) => {
        if (results?.isOk && results?.mailings) {
          setMailings(results?.mailings)
        } else {
          alert("Error get mailing")
        }
      })
    }
  }

  useEffect(() => {
    getMailingForThisContent()
  }, [moduleInfos])

  useEffect(() => {
    updateMailingLists({moduleID : moduleInfos.id, length : mailings.length, uuid : moduleInfos.uuid})
  }, [mailings])

  useEffect(() => {
    const updateMailingStatusEvent = (data) => {
      try {
        if (data?.groupeID === groupeID && data.contentID === moduleInfos.id) {
          getMailingForThisContent()
        }
      } catch(e) { console.log(e) }
    }
    socket?.on("updateMailingStatus", updateMailingStatusEvent)
    return () => {
      socket?.off("updateMailingStatus", updateMailingStatusEvent)
    }
  }, [])

  return (
    <>
      <Divider />
      <Box
        sx={{padding:"10px", opacity: hasChanged ? 0.4 : 1}}
        onClick={() => {
          if (hasChanged) {
            alert("Enregister les modifications avant de pouvoir éditer les mailings")
          }
        }}
      >
        <Button style={{display:"none"}} className="getMailingForThisContentClick" onClick={() => { getMailingForThisContent() }} />
        <Box sx={{width:"100%", display:"flex", flexDirection:"column"}}>
          <TableContainer sx={{marginBottom:"10px"}} component={Paper}>
            <Table sx={{ minWidth: "100%" }} size="small" aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell><font style={{fontSize:"16px"}}>Mailing</font> - Nom</TableCell>
                  <TableCell sx={{width:"200px"}}>Timing</TableCell>
                  <TableCell sx={{width:"90px"}}>Destinataires</TableCell>
                  <TableCell sx={{width:"60px"}}>Status</TableCell>
                  <TableCell align="center" sx={{width:"45px"}}>Edit</TableCell>
                  <TableCell align="center" sx={{width:"45px"}}>Suppr</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {mailings.map((mailing, index) => {
                  return (
                    <TableRow
                      key={mailing.id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {mailing.name}
                      </TableCell>
                      <TableCell sx={{width:"200px"}}>
                        {mailing.deltaTimingUnit2}{mailing.deltaTimingOperator2}{mailing.deltaTimingNbr2}
                        {" et "}
                        {mailing.deltaTimingUnit}{mailing.deltaTimingOperator}{mailing.deltaTimingNbr}
                        {", "}
                        {mailing.timingSource === "closeDate" && "date de fin"}
                        {mailing.timingSource === "openDate" && "date de début"}
                        <br/>
                        ({Moment(mailing.finalTiming).format("DD/MM/YYYY HH:mm")})
                      </TableCell>
                      <TableCell sx={{width:"90px"}}>
                        {mailing.mailDest === "all" && "Tous"}
                        {mailing.mailDest === "notStarted" && "N'ayant pas commencé"}
                        {mailing.mailDest === "inProgress" && "En cours"}
                        {mailing.mailDest === "ended" && "Ayant terminé"}
                      </TableCell>
                      <TableCell sx={{width:"60px"}}>
                        {mailing.status === "todo" &&
                          <font
                            color="orange"
                            style={{cursor: !hasChanged && "pointer", userSelect:"none"}}
                            onClick={() => {
                              if (!hasChanged) {
                                muiConfirm({ title: "Êtes vous sûrs ?", description: "Voulez-vous vraiment forcer l'envoi ?", confirmationText:"Envoyer", cancellationText:"Annuler"})
                                  .then(() => {
                                    APIS.forceSendingMailing({id : mailing.id }).then((result) => {
                                      if (result?.isOk === true) {
                                        getMailingForThisContent()
                                        alert("Mailing traité")
                                      } else {
                                        alert("Error")
                                      }
                                    })
                                  })
                                  .catch(() => { });
                              }
                            }}
                          >
                            À traiter
                          </font>
                        }
                        {mailing.status === "ok" && <font color="green">Traité</font>}
                      </TableCell>
                      <TableCell align="center" sx={{padding:0, width:"45px"}}>
                        {mailing.status === "todo" &&
                          <EditIcon
                            style={{cursor: !hasChanged && "pointer"}}
                            color="black"
                            size={21}
                            onClick={() => {
                              if (!hasChanged) {
                                setActEditMailing(mailing.id)
                                setDialogOpen(true)
                              }
                            }}
                          />
                        }
                      </TableCell>
                      <TableCell align="center" sx={{padding:0, width:"45px"}}>
                        {mailing.status === "todo" &&
                          <TrashIcon
                            style={{cursor: !hasChanged && "pointer"}}
                            color="black"
                            size={21}
                            onClick={() => {
                              if (!hasChanged) {
                                muiConfirm({ title: "Êtes vous sûrs ?", description: "La suppression d'un mailing est définitive.", confirmationText:"Supprimer", cancellationText:"Annuler"})
                                  .then(() => {
                                    APIS.removeMailing({id : mailing.id, groupeID : groupeID, contentID : moduleInfos.id}).then((result) => {
                                      if (result?.isOk === true) {
                                        if (result?.mailings) { setMailings(result?.mailings) }
                                      } else {
                                        alert("Error")
                                      }
                                    })
                                  })
                                  .catch(() => { });
                                }
                            }}
                          />
                        }
                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box sx={{width:"100%", display:"flex", justifyContent:"flex-end"}}>
          <Button
            disabled={hasChanged || moduleInfos && moduleInfos.id === undefined}
            variant="contained"
            sx={{ minHeight:"35px !important" }}
            onClick={() => { setDialogOpen(true)}}
          >
            Créer un mailing
          </Button>
        </Box>


        <Dialog
          fullWidth={true}
          maxWidth={false}
          open={dialogOpen}
          onClose={() => { }}
          PaperProps={{
            sx : {
              color:"black",
            }
          }}
        >
          <DialogContent
            title={"Mailing"}
            moduleInfos={moduleInfos}
            groupeName={groupeName}
            groupeID={groupeID}
            subTitle={"(Groupe "+groupeName+" - Module "+moduleInfos.name+")"}
            onClose={() => { setDialogOpen(false); setActEditMailing(null); }}
            getMailingForThisContent={getMailingForThisContent}
            mailings={mailings}
            actEditMailing={actEditMailing}
            user={currentUser}
          />
        </Dialog>
      </Box>
    </>
  )
};

export default GroupMailing;
